import styled from 'styled-components';

export const ChartContainer = styled.div`
  overflow-y: visible;
  position: relative;
`;

export const TotalArea = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
